module.exports = __webpack_public_path__ + "img/penilaian-buku-teks-pendamping.95bae858.jpeg";